import { Component, effect, input, model } from '@angular/core';
import { AvatarComponent, AvatarSize, AvatarStatus } from '../avatar/avatar.component';
import { SafeHtml } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../icon/icon.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TooltipDirective } from '../../directives/tooltip/tooltip.directive';

@Component({
  selector: 'work-ui-infoblock',
  templateUrl: './infoblock.component.html',
  styleUrls: ['./infoblock.component.scss'],
  standalone: true,
  imports: [NgClass, NgTemplateOutlet, RouterLink, IconComponent, AvatarComponent, TooltipDirective],
})
export class InfoblockComponent {
  public iconName = input('wb_sunny');
  public label = input<string | SafeHtml | null | undefined>('');
  /** Info-Icon mit Tooltip neben dem Label */
  public labelTooltip = input<string | null | undefined>('');
  public title = input.required<string | SafeHtml | null | undefined>();
  public subtitle = input<string | SafeHtml | null | undefined>('');
  public clickable = model(false);
  public textCenteredVertically = input(false);
  public href = input('');
  public route = input<any>('');
  public externalLink = input(false);
  public warning = input(false);
  public fullHeight = input(false);
  public smallIcon = input(false);
  public withAvatar = input(false);
  public avatarImgSrc = input<string | null>('');
  public avatarStatus = input<AvatarStatus>('available');
  public avatarSize = input<AvatarSize>('default');
  public avatarSquare = input(false);
  public listElement = input(false);
  public withBorder = input(false);

  private routeEffect = effect(() => {
    if (this.route() === null) {
      this.clickable.set(false);
    }
  });
}
